import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

import { firstValueFrom, lastValueFrom } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AdminSetPostTrackingPaymentComponent } from './admin-set-post-tracking-payment/admin-set-post-tracking-payment.component';
import { AdminOrderPreviewComponent } from '../../../dialogs/admin-order-preview/admin-order-preview.component';

import {
  getMainFileOrError,
  OrderStatuses,
  PaymentEntity,
  PrintBlockItem,
  Order,
  OrderInfo,
  PaymentErrorType,
} from 'src/app/shared';

import {
  PrintBlockStockNameTypeRegex,
  ConfigService,
  PaymentStatus,
  PaymentErrors,
} from 'src/app/core';

import { OrderService } from 'src/app/feature/services';
import { PaymentService } from 'src/app/feature/payment/services';
import { SubSink } from 'subsink';
import { PaymentOrderFactorComponent } from 'src/app/feature/payment/components/payment-order-factor/payment-order-factor.component';
const _ = require('lodash');

type NextStatusValidation = {
  ok: boolean;
  error?: string | undefined;
};

@Component({
  templateUrl: './payment-control.component.html',
  styleUrls: ['./payment-control.component.sass'],
})
export class PaymentControlComponent implements OnInit, AfterViewInit {
  @ViewChild('errorMessage') errorMessageTextarea: any;

  // ----------------------------------- Public Properties|

  public isReady: boolean = false;
  public ordersInfo: Order[] | undefined = [];
  public ordersTypeKeys: string[] = [];
  public payment!: PaymentEntity;

  public paymentErrors = PaymentErrors;
  public selectedType: PaymentErrorType = 'FILE_BROKEN';
  public paymentErrorStatus: PaymentStatus | undefined = PaymentStatus.NotDone;

  public anyChangeHappened = false;
  public paymentStatuses = PaymentStatus;

  public subsink = new SubSink();

  public nextStatus!: PaymentStatus;
  public nextStatusPersianWord!: string;
  public nextStatusProceedValidation!: NextStatusValidation;
  public currentStatusPersianWord!: string;
  public currentStatus!: PaymentStatus;
  public updateStatusLoading = false;

  // ----------------------------------- Getters and Setters|

  // public get flatOrdersInfo(): OrderInfo[] {
  //   const twoDArray = _.map(this.ordersTypeKeys, (key: string) => {
  //     return this.ordersInfo[key];
  //   });

  //   return _.flatten(twoDArray);
  // }

  // ----------------------------------- Constructors|

  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private orderService: OrderService,
    private configService: ConfigService,
    private paymentService: PaymentService,
    private dialogRef: MatDialogRef<PaymentControlComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { payment: PaymentEntity }
  ) {
    this.payment = data.payment;
    this.ordersInfo = data.payment.orders;
    // this.ordersInfo = this.orderService.getOrdersInfo(this.payment.orders!);

    setTimeout(() => {
      console.log(this.ordersInfo);
    }, 5000);

    // this.ordersTypeKeys = Object.keys(this.ordersInfo);

    this.constructStatus();

    this.isReady = true;
  }

  ngOnInit(): void {}
  ngAfterViewInit(): void {}

  // ----------------------------- Public methods|

  public generateOrderFactor(info: OrderInfo) {
    this.dialog.open(PaymentOrderFactorComponent, {
      data: {
        orderInfo: info,
        payment: this.payment,
        // index: this.flatOrdersInfo.indexOf(info),
        total: this.payment.orders?.length,
      },
    });
  }

  public constructStatus() {
    this.currentStatus = this.payment.status!;
    this.nextStatus = this.paymentService.getPaymentNextStatus(
      this.payment.status
    );

    this.nextStatusPersianWord = this.paymentService.getPersianStatusForPayment(
      this.nextStatus
    );

    this.currentStatusPersianWord =
      this.paymentService.getPersianStatusForPayment(this.payment.status);

    this.nextStatusProceedValidation = this.nextStatusValidation();
  }

  public getDate() {
    return Date.now();
  }

  public getZipDownloadLink(): string {
    return this.configService
      .getUrl('payment.download-all')
      .replace(':id', this.payment.id.toString());
  }

  public getOrderSize(order: Order): string | undefined {
    try {
      return this.orderService.getOrderPageSizes(order).join(' - ');
    } catch (e) {
      return undefined;
    }
  }

  public addError(message: string) {
    if (!message) {
      this.snackBar.open('خطا نمی‌تواند خالی باشد', 'باشه', {
        duration: 1500,
      });
      return;
    }

    const status = this.paymentErrorStatus;
    this.subsink.sink = this.paymentService
      .addError(this.payment.id, this.selectedType, message, status)
      .subscribe({
        next: (paymentError) => {
          this.snackBar.open('خطا با موفقیت اضافه شد', 'باشه', {
            duration: 1500,
          });

          if (paymentError.payment) {
            this.payment.status = paymentError.payment.status;
          }

          this.constructStatus();
          this.errorMessageTextarea.nativeElement.value = '';
        },
        error: () => {
          this.snackBar.open('متاسفانه خطایی رخ داده است', 'باشه', {
            duration: 1500,
          });
        },
      });
  }

  public getOrderImages(order: Order) {
    try {
      return order.files.filter((file) => {
        return file.mimetype.startsWith('image');
      });
    } catch (e) {
      return [];
    }
  }

  public halfColorfulBlocks(order: Order): PrintBlockItem[] {
    try {
      return _.filter(
        getMainFileOrError(order?.files).fileBlocks,
        (item: any) =>
          PrintBlockStockNameTypeRegex.halfColorful.test(item?.stock?.type!)
      )!;
    } catch (e) {
      return [];
    }
  }

  public colorfulBlocks(order: Order): PrintBlockItem[] {
    try {
      return _.filter(getMainFileOrError(order.files).fileBlocks, (item: any) =>
        PrintBlockStockNameTypeRegex.colorful.test(item?.stock?.type!)
      );
    } catch (e) {
      return [];
    }
  }

  public blackWhiteBlocks(order: Order): PrintBlockItem[] {
    try {
      return _.filter(
        getMainFileOrError(order?.files).fileBlocks,
        (item: any) =>
          PrintBlockStockNameTypeRegex.blackAndWhite.test(item?.stock?.type!)
      )!;
    } catch (e) {
      return [];
    }
  }

  public isOrderDone(order: Order): boolean {
    try {
      return order.status === 'done';
    } catch (e) {
      return false;
    }
  }

  public isTwoSided(order: Order): boolean {
    try {
      return this.orderService.isOrderTwoSided(order);
    } catch (e) {
      return false;
    }
  }

  public getTypeInPersian(mode: Order['type']) {
    try {
      switch (mode) {
        case 'print':
          return 'پرینت';

        case 'thesis':
          return 'پایان‌نامه';

        case 'thesis-edit':
          return 'ویرایش پایان‌نامه';

        default:
          return 'نامشخص';
      }
    } catch (e) {
      return 'نامشخص';
    }
  }

  public nextStatusValidation(): NextStatusValidation {
    switch (this.nextStatus) {
      case PaymentStatus.Implementation:
        return { ok: true };

      case PaymentStatus.Done:
        // if (this.isEveryOrderDone()) {
        //   return { ok: true };
        // } else {
          return {
            ok: false,
            error: 'لطفا برای رفتن به مرحله بعد همه سفارشات را انجام دهید',
          };
        // }

      case PaymentStatus.Sent:
        if (this.payment?.postTrackingCode) {
          return { ok: true };
        }

        return {
          ok: false,
          error: 'لطفا کد پیگیری پستی را برای سفارش ثبت کنید',
        };

      case PaymentStatus.Canceled:
        return {
          error: 'سفارشات لغو شده غیر قابل انجام هستند',
          ok: false,
        };

      case PaymentStatus.Payment:
        return {
          ok: false,
          error: 'تا قبل از پرداخت نمیتوانید به مرحله بعد بروید',
        };

      default:
        throw new Error('Unable to validate next status: ' + this.nextStatus);
    }
  }

  /**
   * Update status to next chosen status.
   */
  public updateStatusToNext() {
    if (!this.nextStatusProceedValidation.ok) {
      return;
    }

    this.updateStatusLoading = true;
    this.paymentService
      .updatePaymentStatus(this.payment.id, this.nextStatus)
      .then((payment) => {
        this.payment = payment;

        this.nextStatus = this.paymentService.getPaymentNextStatus(
          payment.status
        );

        this.nextStatusPersianWord =
          this.paymentService.getPersianStatusForPayment(this.nextStatus);

        this.nextStatusProceedValidation = this.nextStatusValidation();
        this.currentStatusPersianWord =
          this.paymentService.getPersianStatusForPayment(payment.status);

        this.updateStatusLoading = false;
        this.currentStatus = payment.status!;
        this.snackBar.open('با موفقیت انجام شد.', '', {
          duration: 1000,
        });
      })
      .catch((error) => {
        this.updateStatusLoading = false;
        this.snackBar.open('مشکلی در رفتن به مرحله بعد پیش آمد.');
      });
  }

  /**
   * Mark one single order as done and update locally
   * @param order {Order} The order you want to mark it as done.
   * @param i Index of order on payment.orders array.
   */
  public async markOrderAsDone(
    orderInfo: OrderInfo,
    key: string,
    i: number
  ): Promise<void> {
    const order = orderInfo.instance;

    switch (order.type) {
      case 'print':
        await this.updateOrderStatus('done', order, key, i);
        break;

      case 'thesis':
        await this.updateOrderStatus('done', order, key, i);
        break;

      case 'thesis-edit':
        this.dialog.open(AdminOrderPreviewComponent, {
          data: order,
          maxHeight: '500px',
          maxWidth: '700px',
        });

        this.snackBar.open('باید فایل پروسه انجام شود', '', { duration: 1000 });
        break;
    }

    this.nextStatusProceedValidation = this.nextStatusValidation();
  }

  /**
   * Mark one single order as undone.
   * @param order Order you want to mark it to in progress
   * @param i Index of order in payment.orders array.
   */
  public async markOrderAsUndone(
    orderInfo: OrderInfo,
    key: string,
    i: number
  ): Promise<void> {
    const order = orderInfo.instance;

    switch (order.type) {
      case 'print':
        await this.updateOrderStatus('progress', order, key, i);
        break;
      case 'thesis':
        await this.updateOrderStatus('progress', order, key, i);
        break;
      case 'thesis-edit':
        this.snackBar.open('باید فایل پروسه اپلود شود');
        break;
    }
    this.nextStatusProceedValidation = this.nextStatusValidation();
  }

  /**
   * Update order status to new one and update
   * it locally on payment object
   *
   * @param to {OrderStatuses} New status.
   * @param order {Order} Order you want to update it's status.
   * @param i {Number} Index of order in array.
   */
  public async updateOrderStatus(
    to: OrderStatuses,
    order: Order,
    key: string,
    i: number
  ) {
    const parent = this;
    try {
      parent.updateStatusLoading = true;

      const result: Order = await firstValueFrom(
        parent.orderService.updateStatus(order.id, to)
      );

      // parent.ordersInfo[key][i]!.status = result.status;
      // parent.ordersInfo[key][i]!.instance.status = result.status;

      parent.updateStatusLoading = false;
    } catch (e) {
      parent.updateStatusLoading = false;
      console.error(e);
      throw new Error(`Problem with updating order ${order.id} to ${to}`);
    }
  }

  public async updatePostalTrackingCode() {
    const code = await lastValueFrom(
      this.dialog
        .open(AdminSetPostTrackingPaymentComponent, {
          height: '400px',
          width: '400px',
        })
        .afterClosed()
    );

    if (code) {
      const payment =
        await this.paymentService.overwritePaymentPostTrackingCode(
          this.payment.id,
          code
        );

      this.payment = payment;
      this.snackBar.open('کد رهگیری ثبت شد', '', { duration: 1000 });
      this.nextStatusProceedValidation = this.nextStatusValidation();
    }
  }

  public downloadEveryFiles(): void {}
  public printFactor() {}
  public printFactors() {}
  public cancelWithError() {}

  public closeDialogBox() {
    this.dialogRef.close(this.anyChangeHappened);
  }

  // // ------------------------------ Private methods|

  // /**
  //  * If you need to mark payment status as Done
  //  * you need to check if every order is done and ready.
  //  * @returns {boolean}
  //  */
  // private isEveryOrderDone(): boolean {
  //   if (!this.payment.orders) {
  //     return false;
  //   } else if (this.payment?.orders?.length <= 0) {
  //     return false;
  //   }
  //   return this.flatOrdersInfo.every(
  //     (info: OrderInfo) => info && info.status === 'done'
  //   );
  // }
}
